import _typeof from "@babel/runtime/helpers/typeof";

/**
 * Created by haikuan.gu@qunar.com
 * Date: 2020/5/26
 * Time: 10:26 上午
 *
 */
// eslint-disable-next-line import/no-unresolved
import qs from 'qs';
import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route } from 'react-router-dom';
import { AppRegistry } from 'react-native';
import mixRedux from './mix-redux';
import Bridge from '../bridge';
import errorHandler from '../errorHandler';
var isArray = Ext.utils.isArray;
var rootTagKey = '__rootTag_do_not_change_or_you_will_be_fired';
/**
 * 存放所有页面的容器
 * @type {Object}
 * @example
 * views = {
 *     pageA: {
 *         Component,   // viewClass
 *     }
 * }
 */

var views = {}; // 异步加载页面资源的函数工具

var viewsAsyncRequire = {}; // 已经分配的 tag -> viewName 的 map

var hasAllocatedRootTagMap = {}; // 已经执行了 setView 的页面，
// 为了导航栏设置标题和控制 modal mask 的区域

var hasInvokedSetViewNameKey = {}; // 当前打开的页面的名字

var Router = {
  setTitle: function setTitle(title) {
    document.title = title;
  }
};

function registryComponent(className, Component) {
  if (!Ext.defaults.indexView) {
    Ext.defaults.indexView = className; // 保留之前的 indexView 的配置方式，有个提示，需要在某版修改

    if (Ext.defaults.appName !== 'naive') {
      console.warn('Ext.defaults.appName 不再使用，请及时删除该行配置');
    }
  }

  views[className] = {
    Component: Component
  }; // spa方式

  if (Ext.defaults.SPA_CONFIG) {
    return mixRedux.wrapperView(className, Component);
  }

  AppRegistry.registerComponent(className, function () {
    return mixRedux.wrapperView(className, Component);
  });
  var query = qs.parse(window.location.search.replace('?', ''));
  var title = query.title,
      _query$pageName = query.pageName,
      pageName = _query$pageName === void 0 ? Ext.defaults.indexView : _query$pageName,
      param = query.param; // 适配非 ext跳转 url

  if (!param) {
    param = query;
  }

  if (typeof param === 'string') {
    param = JSON.parse(decodeURIComponent(param));
  }

  if (title) {
    document.title = title;
  } // console.log('---initialProps param---', param)


  if (pageName === className) {
    AppRegistry.runApplication(pageName || Ext.defaults.indexView, {
      rootTag: document.getElementById('app'),
      initialProps: {
        param: param || {}
      }
    });
  }
}

Ext.addPlugin('router', function (context) {
  var pOpts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var React = arguments.length > 2 ? arguments[2] : undefined;
  var isView = arguments.length > 3 ? arguments[3] : undefined;
  // eslint-disable-next-line no-mixed-operators
  var rootTag = context.props && context.props[rootTagKey] || '';

  if (!isView || !rootTag || hasAllocatedRootTagMap[rootTag]) {
    return;
  }

  var viewName = context.constructor.className;
  var bindEvents = context.bindEvents || {};
  var listenerViewKey = "".concat(viewName, "_").concat(rootTag); // eslint-disable-next-line no-multi-assign

  var listeners = Router._lifecycleListeners[listenerViewKey] = {}; // 防止出现 QView 包 QView 的情况

  if (rootTag) {
    hasAllocatedRootTagMap[rootTag] = viewName;
  }

  if (typeof context.onBackPressed === 'function') {
    listeners.onBackPressed = context.onBackPressed.bind(context);
  }

  for (var key in bindEvents) {
    if (Ext.utils.isFunction(bindEvents[key])) {
      listeners[key] = bindEvents[key].bind(context);
    }
  }
}, null, function (Component, isView, plugins, className) {
  // 保存 className, 打包压缩之后找不到
  Component.className = className; // 针对 redux connect 封装的组件名字缓存处理

  if (Component.WrappedComponent) {
    Component.WrappedComponent.className = className;
  } // 获取 Component


  if (isView) {
    if (Ext.defaults.SPA_CONFIG) {
      return registryComponent(className, Component);
    }

    registryComponent(className, Component);
  }
});
/** ***********************
 * Router API
 *********************** */

/**
 * [API] open
 * @param  {String} name 页面名字
 * @param  {Object} opts 参数
 * @return {Boolean} 执行结果（true为成功 ，false 为失败）
 */

Router.open = function (name) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var param = opts.param || {};
  var spaConfig = Ext.defaults.SPA_CONFIG || {};
  var pageInfo = spaConfig[name];

  if (pageInfo && opts.history && Ext.utils.isFunction(opts.history.push)) {
    opts.history.push({
      pathname: isArray(pageInfo.path) ? pageInfo.path[0] : pageInfo.path,
      query: param
    });
    return true;
  }

  delete opts.history;
  opts.pageName = name;

  if (opts.param) {
    opts.param = encodeURIComponent(JSON.stringify(opts.param));
  }

  var url = "".concat(window.location.origin, "?").concat(qs.stringify(opts));

  if (url.length > 2038) {
    throw Error('url is too long');
  }

  window.location.search = "?".concat(qs.stringify(opts));
  return true;
};
/**
 * [API] openShark
 * @param  {Object} opts 参数
 * @return {Boolean} 执行结果（true为成功 ，false 为失败）
 */


Router.openShark = function () {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  console.log('Router.openShark----', opts);
  var url = "".concat(window.location.origin).concat(window.location.pathname, "?").concat(qs.stringify(opts));

  if (url.length > 2038) {
    throw Error('url is too long');
  }

  console.log(url);
  window.location.href = url;
  return true;
};
/**
 * [API] back
 * @param  {Object} opts 参数
 * @return {Boolean} 执行结果（true为成功 ，false 为失败）
 */


Router.back = function (opts) {
  if (opts.history && Ext.utils.isFunction(opts.history.goBack)) {
    opts.history.goBack();
    return true;
  }

  window.history.back();
  return true;
};
/**
 * [API] backTo
 * @param  {String} name 页面名字
 * @param  {Object} opts 参数
 * @param  {Object} _fromGoto 来自内部方法 Router.goto 的标志
 * @return {Boolean} 执行结果（true为成功 ，false 为失败）
 */


Router.backTo = function () {
  errorHandler.warn('Router.backTo is not support');
  return false;
};
/**
 * [API] goto
 * @param  {String} name 页面名字
 * @param  {Object} opts 参数
 * @return {Boolean} 执行结果（true为成功 ，false 为失败）
 */


Router["goto"] = function (name) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var res = Router.backTo(name, opts, true);

  if (!res) {
    res = Router.open(name, opts);
  }

  return res;
};
/**
 * [API] home
 * @param  {Object} opts 参数
 * @return {Boolean} 执行结果（true为成功 ，false 为失败）
 */


Router.home = function () {
  errorHandler.warn('Router.home is not support');
  return true;
};
/**
 * [API] close
 * @param  {String} name 页面名字
 * @return {Boolean} 执行结果（true为成功 ，false 为失败）
 */


Router.close = function () {
  errorHandler.warn('Router.close(name) is not support');
  return false;
}; // @redux 强行包裹 Router.open 方法


mixRedux.wrapperRouter(Router); // 暴露一下

Router.Bridge = Bridge;
Router._views = views;
Router._hasAllocatedRootTagMap = hasAllocatedRootTagMap;
Router._viewsAsyncRequire = viewsAsyncRequire; // 每个 rn 页面的生命周期回调

Router._lifecycleListeners = {};
Router._hasInvokedSetViewNameKey = hasInvokedSetViewNameKey;
Ext.Router = Router;
Ext.Router.navBar = {
  setTitle: Ext.Router.setTitle
};
Ext.open = Router.open;
Ext.openShark = Router.openShark;
Ext.back = Router.back;
Ext.backTo = Router.backTo;
Ext["goto"] = Router["goto"];
Ext.home = Router.home;
Ext.close = Router.close;
Ext.exit = Router.exit;

Ext.setSwipeBackEnabled = function (isEnabled) {
  Bridge.setSwipeBackEnabled(isEnabled);
};

Ext.showNavigationBarMask = function () {
  throw Error('Ext.showNavigationBarMask is not support');
};

Ext.hideNavigationBarMask = function () {
  throw Error('Ext.showNavigationBarMask is not support');
};

Ext.registerView = function (name, callback) {
  if (typeof callback !== 'function') {
    throw new Error("Ext.registerView(name, callback) \u4E2D\u7684 callback \u53C2\u6570\u5FC5\u987B\u662F\u51FD\u6570\u7C7B\u578B\uFF0C\u73B0\u5728\u4F20\u5165\u7684\u662F ".concat(_typeof(callback)));
  } // 等业务逻辑搞定时，执行一下 init


  if (!Ext._cache.View) {
    Ext.init();
  }

  viewsAsyncRequire[name] = callback;

  if (callback()["default"]) {
    registryComponent(name, callback()["default"]);
  } else {
    throw new Error('Ext.registerView(name, callback) 中的 callback 参数返回值，无 export.default');
  }
};

Ext.lazy = lazy;

Ext.renderSpa = function () {
  var BasicRoute = function BasicRoute() {
    return <BrowserRouter>
            {
        /* 页面流转loading */
      }
            <Suspense fallback={Ext.defaults.SPA_LOADING || ''}>
                {Object.keys(Ext.defaults.SPA_CONFIG).map(function (key) {
          var config = Ext.defaults.SPA_CONFIG[key];
          return <Route key={config.path} exact path={config.path} component={config.page} />;
        })}
          </Suspense>
      </BrowserRouter>;
  };

  ReactDOM.render(<BasicRoute />, document.getElementById('app'));
};

export default Router;